import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { integrationConnectionWithAccountsResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";

const c = initContract();

export const gustoIntegrationContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: z.object({
                code: z.string(),
                defaultEntityId: z.number().optional(),
                /**
                 * Omitted when an accounting firm connects from the
                 * organization view: the connection is created without a
                 * client and its accounts are assigned afterwards.
                 */
                workspaceId: z.string().uuid().optional(),
            }),
            responses: {
                200: integrationConnectionWithAccountsResponseSchema,
                403: z.object({ message: z.string() }),
                409: z.object({ message: z.string() }),
            },
        },
        syncConnection: {
            method: "POST",
            path: "/sync/:connectionId",
            pathParams: z.object({
                connectionId: z.string().uuid(),
            }),
            query: z.object({
                workspaceId: z.string().uuid(),
            }),
            body: c.noBody(),
            responses: {
                200: integrationConnectionWithAccountsResponseSchema,
                400: z.object({ message: z.string() }),
            },
        },
        getConnections: {
            method: "GET",
            path: "/",
            responses: {
                200: z.array(integrationConnectionWithAccountsResponseSchema),
            },
        },
        getConnectionForEntity: {
            method: "GET",
            path: "/entity/:entityId",
            pathParams: z.object({
                entityId: z.coerce.number(),
            }),
            responses: {
                200: integrationConnectionWithAccountsResponseSchema.nullable(),
            },
        },
    },
    { pathPrefix: "/gusto" },
);
